// extracted by css-extract-rspack-plugin
export default {"cardContent":"card-content--uMnM0QNT904c1yrp"};